export default __webpack_public_path__ + "static/media/broadcast-tags.c94b4568.png";